import React, {useCallback, useEffect, useState} from 'react';
import {Formik} from "formik";
import FieldCustom from "../Field/FieldCustom";
import loginForm from "../Login/LoginForm";
import AxiosConfig from "../../services/AxiosConfig";
import styles from './../Search/Search.module.css';
import {registerUserToSeanceByCoachAPI} from "../../services/SeanceService";
import {useModal} from "../../contexts/ModalContext";
import {searchCoachs, searchReferents, searchUsers} from "../../services/SearchService";

const SearchUtilisateur = ({ entrepriseId = null, onSubmit= null }) => {
    const [suggestions, setSuggestions] = useState([]);
    const { showModal } = useModal();

    const handleSuccess = useCallback((message = "Succès") => {
        showModal('success', { children: message, timeout: 3000 });
    }, [showModal]);

    const handleError = useCallback((message = "Une erreur est survenue") => {
        showModal('error', { children: message, timeout: 3000 });
    }, [showModal]);

    const fetchSuggestions = async (value) => {
        if (!value) {
            setSuggestions([]);
            return;
        }
        const response = await searchUsers(value, entrepriseId);
        setSuggestions(response);
    };

    const handleInputChange = async (e, setFieldValue) => {
        const value = e.target.value;
        setFieldValue('email', value);
        await fetchSuggestions(value);
    };

    const handleSuggestionClick = (suggestion, setFieldValue, handleSubmit) => {
        setFieldValue('email', suggestion.email);
        setFieldValue('id', suggestion.id ?? null);
        setSuggestions([]);
        handleSubmit();
    };

    return (
        <div style={{ display: "flex", flexDirection: "row"}}>
            <Formik
                initialValues={{ email: '' }}
                onSubmit={async (values, {setSubmitting}) => {

                    if (onSubmit) {
                        onSubmit(values);
                    } else {
                        const response = await registerUserToSeanceByCoachAPI(entrepriseId, values)
                        if (response.success) {
                            handleSuccess(response.msg);
                        } else {
                            handleError(response.msg);
                        }
                    }
                    setSubmitting(false);
                }}
            >
                {({ handleSubmit, isSubmitting, setFieldValue }) => (
                    <form onSubmit={handleSubmit} className={styles.searchForm} autoComplete="off">
                        <FieldCustom
                            type={"text"}
                            placeholder={"Recherchez par nom, prénom, email..."}
                            id={"email"}
                            name={"email"}
                            label={""}
                            onChange={(e) => handleInputChange(e, setFieldValue)}
                        />

                        <div className={styles.listeDeroulanteContainer}>
                            {suggestions.length > 0 ? (
                                <ul className="suggestions">
                                    {suggestions.map(suggestion => (
                                        <li key={suggestion.id} onClick={() => handleSuggestionClick(suggestion, setFieldValue, handleSubmit)}>
                                            {suggestion.prenom} {suggestion.nom} - {suggestion.email}
                                        </li>
                                    ))}
                                </ul>
                            ) : null }
                        </div>
                    </form>
                )}
            </Formik>
        </div>
    );
};

export default SearchUtilisateur;
